import {VersionType} from "../../../../__generated__/generated_types";

/**
 * Format a budget year and version type into a string. The budget year is
 * adjusted based on the version so that the correct year is displayed.
 *
 * Example:
 *  budgetYear = 2025
 *  versionType = Reforecast
 *  output = 2024 (Reforecast)
 *
 *  budgetYear = 2025
 *  versionType = Budget
 *  output = 2025 (Budget)
 *
 * @param budgetYear The budget year number.
 * @param versionType The VersionType enum value.
 */
export function formatBudgetYearAndVersionType(budgetYear: any, versionType: any): string {
    if(typeof budgetYear !== "number") {
        return "Budget Year Not a Number";
    }

    if(versionType === VersionType.Reforecast) {
        return `${budgetYear - 1} (Reforecast)`;
    }
    return `${budgetYear} (Budget)`;
}

/**
 * Formats a year version type to a string when the year and version type correspond
 * and not math needs to be done on the year. This is primarily used with drivers.
 *
 * @param year The year number.
 * @param versionType The VersionType enum value.
 */
export function formatYearAndVersionType(year: any, versionType: any): string {
    if(typeof year !== "number") {
        return "Year Not a Number";
    }

    if(versionType === VersionType.Reforecast) {
        return `${year} (Reforecast)`;
    }
    return `${year} (Budget)`;
}

export function budgetSeasonString(budgetYear: any): string {
    if(typeof budgetYear === "number") {
        return `${budgetYear - 1} - ${budgetYear} Budget Season`;
    }
    return "UNKNOWN budget season";
}

export function ensureNotObject(value: any): any {
    if(typeof value === "object" && value !== null) {
        return "";
    }
    return value;
}

export function keyify(value: any): string | number {
    if(typeof value === "number" || typeof value === "string") {
        return value;
    }
    return JSON.stringify(value);
}

export function renderArrayAsJoinedString(arr: any[]): string {
    const stringified = arr.map(v => {
        if(typeof v === "string" || typeof v === "number") {
            return v;
        }
        return "";
    });
    return stringified.join(", ");
}

export function renderPossibleArray(val: any): string {
    if(Array.isArray(val)) {
        return renderArrayAsJoinedString(val);
    }
    return "";
}